import React from 'react';
import axios from "axios";

import { API_BASE_URL4, API_BASE_URL_UAT, API_BASE_URL } from './constant';

class authenticationService extends React.Component {

    signin = async (UserName, Password) => {

        var v_user_list_item = {
            UserName: UserName,
            Password: Password,
        };
    
        const url = API_BASE_URL + 'api/UserListItem/Token/Get/';

        try {
            const response = await axios.post(url, v_user_list_item);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

}

export default new authenticationService();